// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"168":"91b574b3","201":"010fd1a9","243":"6761a2d5"}[chunkId] + ".chunk.css";
};